import { Position, State } from 'src/types'
// 背面の描画
import { indexFingerCover } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/fingerCoverOrPad/indexFingerCover'
import { lace } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lace'
import { lining } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lining'
import { littleHook } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/hooks/littleHook'
import { thumbHook } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/hooks/thumbHook'
import { backLaceDrawer, brandLabelDrawerForGlove } from 'src/features/atoms/glove/drawer/common/useCanvasHelper'
import { webOfGloveBackDrawer } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/web/useCanvasWebsBack'
import {
  liningEmbroideryDrawer,
  liningEmbroideryUsDrawer,
  nonThumbEmbroideryDrawer,
  nonThumbEmbroideryUsDrawer,
  thumbEmbroideryDrawer
} from 'src/features/atoms/glove/drawer/common/back/useCanvasEmbroideries'
import { backStyleOfGloveBackDrawer } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/backStyles'
import { laceOfWristBeltCrossDrawer } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lace/laceOfWristBeltFix'
import { canvasResetter } from 'src/util/canvas'
import { loopOfRingFinger } from 'src/features/atoms/glove/drawer/common/back/loopOfRingFinger'
import { usBeltBackStyleDrawer } from './backStyles/beltBackStyleDrawer'
import { positionChecker, backStyleChecker } from 'src/logic'
import { isDefault_AGL_NE_105 } from 'src/features/atoms/glove/logic'

export const atomsCanvasGloveBack = async (ctx: CanvasRenderingContext2D, state: State, position: Position): Promise<void> => {
  const { isPitcher } = positionChecker(position)
  const fingerGuardType = state.fingerGuardType?.value
  const isIndexFingerCover = fingerGuardType == 'indexCover' || (fingerGuardType === 'unselected' && isPitcher)
  const { isFirstBackStyle } = backStyleChecker(state.backStyle?.value)
  const embroideries = state.embroideries
  const laceColor = state.lace.color
  const stitchColor = state.stitch.color
  const productNumber = state.baseModel.productNumber
  const needCatchFaceWrap = (!state.baseModel?.isUBack && !isFirstBackStyle) || false
  canvasResetter(ctx) // リセット
  lining(ctx, state.linings?.color) // 裏革
  liningEmbroideryDrawer(ctx, embroideries, 'first') // 平裏の刺繍描画1段目
  liningEmbroideryDrawer(ctx, embroideries, 'second') // 平裏の刺繍描画2段目

  if (state.loopOfRingFinger?.value === 'loopOfRingFinger') {
    loopOfRingFinger(ctx, state.loopOfRingFingerColor?.color, stitchColor)
  }
  await backStyleOfGloveBackDrawer(ctx, state, needCatchFaceWrap) // バックスタイルの描画(ハミダシ,親指刺繍含)
  thumbEmbroideryDrawer(ctx, state.embroideries)

  const _isDefault_AGL_NE_105 = isDefault_AGL_NE_105(productNumber, state.webParts.value)
  if (isIndexFingerCover && !_isDefault_AGL_NE_105) {
    await indexFingerCover(ctx, state.indexCover.color, stitchColor, state.printLeatherType?.value) // 指カバー
  }
  nonThumbEmbroideryDrawer(ctx, 'middleFinger', embroideries) // 中指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'ringFinger', embroideries) // 薬指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'childFinger', embroideries) // 小指への刺繍
  await webOfGloveBackDrawer(ctx, state) // ウェブの描画
  lace(ctx, laceColor) // 革紐
  if (![state.backStyle?.value, state?.baseModel?.backStyle].includes('firstBackStyle')) {
    laceOfWristBeltCrossDrawer(ctx, laceColor, isFirstBackStyle)
  }
  backLaceDrawer(ctx, state?.backLace?.value, laceColor, position, productNumber) // 背面紐通し(オプション)
  brandLabelDrawerForGlove(ctx, state) // ラベル描画
  littleHook(ctx, state.littleHook?.color, 25, 240, -10, 0.7) // 小指掛け紐
}

export const atomsUsModelCanvasGloveBack = async (ctx: CanvasRenderingContext2D, state: State, position: Position) => {
  const { isPitcher } = positionChecker(position)
  const productNumber = state.baseModel.productNumber
  const isIndexFingerCover =
    state.fingerGuardType?.value == 'indexCover' || (state.fingerGuardType?.value === 'unselected' && isPitcher && productNumber !== 'AJA-01')
  const { isFirstBackStyle } = backStyleChecker(state.backStyle?.value)
  const needCatchFaceWrap = (!state.baseModel?.isUBack && !isFirstBackStyle) || false
  const laceColor = state.lace.color
  const embroideries = state.embroideries
  const thumbHookColor = state.thumbHook.color

  canvasResetter(ctx) // リセット
  lining(ctx, state.linings?.color) // 裏革
  liningEmbroideryUsDrawer(ctx, embroideries, 'first') // 平裏の刺繍描画1段目
  liningEmbroideryUsDrawer(ctx, embroideries, 'second') // 平裏の刺繍描画2段目
  await usBeltBackStyleDrawer(ctx, state, needCatchFaceWrap) // バックスタイルの描画(ハミダシ,親指刺繍含)
  if (isIndexFingerCover) {
    await indexFingerCover(ctx, state.indexCover.color, state.stitch.color, state.printLeatherType?.value) // 指カバー
  }
  nonThumbEmbroideryUsDrawer(ctx, 'middleFinger', embroideries) // 中指への刺繍
  nonThumbEmbroideryUsDrawer(ctx, 'ringFinger', embroideries) // 薬指への刺繍
  nonThumbEmbroideryUsDrawer(ctx, 'childFinger', embroideries) // 小指への刺繍
  await webOfGloveBackDrawer(ctx, state) // ウェブの描画
  lace(ctx, laceColor) // 革紐
  laceOfWristBeltCrossDrawer(ctx, laceColor, isFirstBackStyle)
  backLaceDrawer(ctx, state?.backLace?.value, laceColor, position, productNumber) // 背面紐通し(オプション)
  brandLabelDrawerForGlove(ctx, state) // ラベル描画
  littleHook(ctx, state.littleHook?.color, 25, 240, -10, 0.7) // 小指掛け紐
  thumbHook(ctx, thumbHookColor, 110, -310, 15) // 先端 // 親指掛け紐
  thumbHook(ctx, thumbHookColor, -14, 30, 0) //手元
}
